import React from 'react';

import { global } from '../../api/global'


function PgaSuporte() {
    /// console.log(global.brl.REACT_APP_EVIPPLAY2ini)
    return (
        <div className="min-h-screen bg-background text-white">
            <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-12">
                {/* Main Heading */}
                <div className="text-center mb-12">
                    <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4">
                        Tutorial de uso
                    </h1>
                    <div className="w-24 h-1 bg-teal-400 mx-auto rounded-full"></div>
                </div>

                {/* Tutorial Videos Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 mb-16">
                    <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700/50 hover:border-teal-500/50 transition-colors duration-300">
                        <div className="aspect-video rounded-xl overflow-hidden mb-4 bg-gray-900">
                            <video 
                                className="w-full h-full object-cover" 
                                controls 
                                autoPlay={false}
                                controlsList="nodownload"
                            >
                                <source src={`${import.meta.env.VITE_EVIPPLAY1ini || ''}tela1.mp4`} type="video/mp4" />
                            </video>
                        </div>
                        <h4 className="text-xl font-semibold text-teal-300 text-center">
                            Como baixar o aplicativo
                        </h4>
                    </div>

                    <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700/50 hover:border-teal-500/50 transition-colors duration-300">
                        <div className="aspect-video rounded-xl overflow-hidden mb-4 bg-gray-900">
                            <video 
                                className="w-full h-full object-cover" 
                                autoPlay={false}
                                controls 
                                controlsList="nodownload"
                            >
                                <source src={`${import.meta.env.VITE_EVIPPLAY1ini || ''}tela2.mp4`} type="video/mp4" />
                            </video>
                        </div>
                        <h4 className="text-xl font-semibold text-teal-300 text-center">
                            Como acessar e criar conta
                        </h4>
                    </div>

                    <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700/50 hover:border-teal-500/50 transition-colors duration-300">
                        <div className="aspect-video rounded-xl overflow-hidden mb-4 bg-gray-900">
                            <video 
                                className="w-full h-full object-cover" 
                                autoPlay={false}
                                controls 
                                controlsList="nodownload"
                            >
                                <source src={`${import.meta.env.VITE_EVIPPLAY1ini || ''}tela3.mp4`} type="video/mp4" />
                            </video>
                        </div>
                        <h4 className="text-xl font-semibold text-teal-300 text-center">
                            Explorando o SMIZE TV
                        </h4>
                    </div>

                    <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700/50 hover:border-teal-500/50 transition-colors duration-300">
                        <div className="aspect-video rounded-xl overflow-hidden mb-4 bg-gray-900">
                            <video 
                                className="w-full h-full object-cover" 
                                autoPlay={false}
                                controls 
                                controlsList="nodownload"
                            >
                                <source src={`${import.meta.env.VITE_EVIPPLAY1ini || ''}tela4.mp4`} type="video/mp4" />
                            </video>
                        </div>
                        <h4 className="text-xl font-semibold text-teal-300 text-center">
                            Configuração de conta
                        </h4>
                    </div>

                    <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-700/50 hover:border-teal-500/50 transition-colors duration-300">
                        <div className="aspect-video rounded-xl overflow-hidden mb-4 bg-gray-900">
                            <video 
                                className="w-full h-full object-cover"  
                                controls 
                                controlsList="nodownload"
                            >
                                <source src={`${import.meta.env.VITE_EVIPPLAY1ini || ''}tela5.mp4`} type="video/mp4" />
                            </video>
                        </div>
                        <h4 className="text-xl font-semibold text-teal-300 text-center">
                            Como assistir às lives
                        </h4>
                    </div>
                </div>

                {/* Contact Information */}
                <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700/50 text-center">
                    <div className="max-w-2xl mx-auto space-y-6">
                        <h3 className="text-2xl font-bold text-teal-300 mb-6">
                            Precisa de mais ajuda?
                        </h3>
                        
                        <p className="text-gray-300 text-lg">
                            Caso tenha alguma dúvida, entre em contato no email
                        </p>

                        <div className="flex items-center justify-center mb-6">
                            <svg className="w-6 h-6 text-teal-400 mr-3" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                            </svg>
                            <a 
                                href="mailto:contato@smize.tv?cc=contato@smize.tv&Subject=Suporte" 
                                className="text-teal-400 hover:text-teal-300 text-xl font-semibold transition-colors duration-200"
                            >
                                contato@smize.tv
                            </a>
                        </div>

                        <div className="border-t border-gray-700 pt-6 space-y-3">
                            <p className="text-gray-300">ou criar um canal ligue</p>
                            
                            <div className="space-y-2">
                                <div className="flex items-center justify-center">
                                    <svg className="w-5 h-5 text-teal-400 mr-3" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                    </svg>
                                    <p className="text-gray-300">Rodrigo Adelino (21) 99885-1057</p>
                                </div>
                                
                                <div className="flex items-center justify-center">
                                    <svg className="w-5 h-5 text-teal-400 mr-3" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                    </svg>
                                    <a 
                                        href="mailto:rodrigo@bascode.com" 
                                        className="text-teal-400 hover:text-teal-300 transition-colors duration-200"
                                    >
                                        rodrigo@bascode.com
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PgaSuporte;